// 一些全局公用的方法，不需要额外在页面引入，可以直接应用
import { getSession } from '@/utils';

export default {
  install(Vue, options) {
    // 当用 v-if 判断权限的时候，用方法 $btnAuth
    // type: 1 按钮权限； 2 菜单权限
    Vue.prototype.$btnAuth = function(key, type = 1) {
      if (type === 1) {
        const btnAuthList = JSON.parse(getSession('btnAuthList'));
        if (!btnAuthList.includes(key)) {
          return false;
        } else {
          return true;
        }
      } else {
        const navSecondList = JSON.parse(getSession('navSecondList'));
        if (!navSecondList.includes(key)) {
          return false;
        } else {
          return true;
        }
      }
    };
  }
};
